import View from '../Support/View/View';

export default class Hero extends View {

    static get viewName() {
        return 'hero';
    }
    static get viewType() {
        return 'component';
    }

    start() {
        this.setParallax();
    }

    setParallax() {
        if (!this.viewData.parallax) {
            return;
        }

        const options = {
            scale: .5,
            overflow: true,
            delay: .6,
            transition: 'cubic-bezier(0, 0, 0, 1)',
        };

        setTimeout(() => {
            new SimpleParallax(this.$el.querySelectorAll('img'), options);
            new SimpleParallax(this.$el.querySelectorAll('video'), options);
            new SimpleParallax(this.$el.querySelectorAll('iframe'), options);
            new SimpleParallax(this.$el.querySelectorAll('.hero-content'), options);
            new SimpleParallax(this.$el.querySelectorAll('.slider-slide-content'), options);
        }, 500);
    }
}